import * as React from "react";
function SvgUsersBang(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle cx={28} cy={28} r={2} />
      <circle
        cx={14}
        cy={10}
        r={7}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M9.11 29H3a11 11 0 0118.54-8"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path d="M26 10a2 2 0 014 0c0 1.1-1 12.45-1 13a1 1 0 01-2 0c0-.55-1-11.9-1-13z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUsersBang);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
